import store from '../store'

export const systemTimezone = () => {
  const list = {
    'eInsight Application': 'ET',
    'eInsight eu01 Application': 'UTC',
    'eInsight aws apac Application': 'UTC',
    'eInsight eu02 Application': 'UTC',
    'eInsight QA Application': 'ET',
    'eInsight Stage Application': 'ET'
  }
  return list[store.state.manageCampaigns.environmentName]
}

export const isTimeZoneFeatureEnabled = () => {
  const isActive = Number(store.state.manageCampaigns.campaignTimezoneEnable.settingValue)
  return Boolean(isActive)
}
